import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatInputModule } from "@angular/material/input";
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink, 
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule
],
  templateUrl: './unauthorized.html',
})
export class UnauthorizedComponent {}